export enum IdType {
  NATIONAL = "Nacional",
  PASSPORT = "Pasaporte",
  RESIDENT = "Residente",
}

export enum VehicleClass {
  PRIVATE = "Automóvil / SUV",
  PICKUP = "Pick-up",
  BIKE = "Motocicletas",
}

export enum UseType {
  PERSONAL = "Personal",
  COMMERCIAL = "Comercial",
}

export type Currency = "$" | "₡";

export interface CustomerFormInfo {
  idType: IdType;
  idNumber: string;
  name: string;
  firstLastName: string;
  secondLastName: string;
  email: string;
  phone: number;
  valid: boolean;
  company: string;
}

export interface VehicleFormInfo {
  class: VehicleClass;
  make: string;
  model: string;
  version: string;
  year: number;
  type: UseType;
  insuranceAmount: number;
  currency: Currency;
}

export interface FormProps {
  nextStep: () => void;
}
